module.exports = __webpack_public_path__ + "img/login.9094daf0.svg";